<template>
  <div
    class="form-input-group"
    v-bind="$parentAttrs"
  >
    <label
      :class="{ 'with-error': false, filled: true, 'tw-overflow-y-auto': true }"
    >
      <textarea
        v-bind="$childAttrs"
        class="textarea"
        :class="targetClass"
        :value="modelValue"
        :placeholder="defaultPlaceholder"
        :required="required"
        @input="(event) => $emit('update:modelValue', event.target.value)"
      />

      <div
        v-if="label"
        class="label"
      >
        {{ label }}
        <sup class="tw-text-red">{{ required ? '*' : '' }}</sup>
      </div>
    </label>
  </div>
</template>

<script>
import attrsMixin from '@/mixins/attrs.js'

export default {
  name: 'TextareaInput',
  mixins: [attrsMixin],
  props: {
    label: {
      type: String,
      default: null,
    },
    modelValue: {
      type: [String, Number, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    targetClass: {
      type: [Array, String, Object],
      default: null,
    },
  },
  data() {
    return {
      defaultPlaceholder: this.placeholder ? this.placeholder : this.label,
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('update:modelValue', e)
    },
  },
}
</script>
